import httpClient from "./http-client"
import api from "./api"

const client = httpClient.getInstance()

export const backervoiceApi = api(client)
